import {registerComponent} from './CityChooser';
import {bindEvents} from './QuickCityChooser.js';
import Vue from 'vue';

function initSaleLocationSelectorSearch() {
    registerComponent();
    document.querySelectorAll('[is="city-chooser"]')
        .forEach(elem => new Vue({el: elem}));
    document.querySelectorAll('[is="quick-city-chooser"]')
        .forEach(bindEvents);
}

BX.namespace('SaleLocationSelectorSearch');

BX.SaleLocationSelectorSearch.init = initSaleLocationSelectorSearch;

export default initSaleLocationSelectorSearch;
